import { useLanguage } from "@/contexts/LanguageContext";

const DASHBOARD_IMG = "https://d2xsxph8kpxj0f.cloudfront.net/111011785/VdQVYstYWxPmJs2memuh7b/mockup_dashboard_26622aa7.png";

export default function Hero() {
  const { t } = useLanguage();

  return (
    <section className="relative pt-20 pb-28 px-6 hero-bg overflow-hidden border-b border-white/10" data-testid="hero-section">
      <div className="absolute inset-0 pointer-events-none opacity-40">
        <div className="absolute -top-40 right-10 w-96 h-96 rounded-full bg-[#223C54] blur-3xl"></div>
        <div className="absolute bottom-0 left-10 w-80 h-80 rounded-full bg-[#581222]/40 blur-3xl"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10 grid md:grid-cols-12 gap-12 items-center">
        <div className="md:col-span-7">
          <div className="inline-flex items-center gap-2 px-3 py-1 border border-white/10 bg-white/5 text-[#E2C079] text-xs font-mono-code tracking-widest uppercase mb-6 fade-sub" data-testid="hero-badge">
            <span className="w-1.5 h-1.5 rounded-full bg-[#E2C079]"></span>
            <span>{t.hero.badge}</span>
          </div>

          <h1 className="font-serif-didot text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-[1.05] text-balance mb-6" data-testid="hero-title">
            <span className="ln"><span>{t.hero.line1}</span></span>
            <span className="ln"><span className="text-[#E2C079] italic">{t.hero.line2}</span></span>
          </h1>

          <p className="fade-sub text-base sm:text-lg text-white/70 max-w-xl font-light leading-relaxed mb-8" data-testid="hero-description">
            {t.hero.description}
          </p>

          <div className="fade-cta flex flex-wrap items-center gap-4">
            <a
              href="#licenza"
              data-testid="hero-buy-button"
              className="px-7 py-3.5 bg-[#E2C079] text-[#0b131e] font-semibold text-xs tracking-widest uppercase hover:bg-white transition-colors duration-300 shadow-lg shadow-[#E2C079]/10"
            >
              {t.hero.buy}
            </a>
            <a
              href="#contatto"
              data-testid="hero-demo-button"
              className="px-7 py-3.5 border border-white/20 text-white text-xs tracking-widest uppercase hover:border-[#E2C079] hover:text-[#E2C079] transition-colors duration-300"
            >
              {t.hero.demo}
            </a>
          </div>
        </div>

        <div className="md:col-span-5 fade-card">
          <div className="relative rounded-lg p-1 bg-gradient-to-b from-[#E2C079]/30 via-white/10 to-transparent">
            <div
              className="relative rounded bg-[#0f1b29] p-6 border border-white/10 overflow-hidden shadow-2xl drift-slow"
              style={{
                backgroundImage:
                  "radial-gradient(120% 90% at 20% 15%, #223C54 0%, transparent 60%), radial-gradient(90% 80% at 80% 80%, #581222 0%, transparent 70%), linear-gradient(145deg, #0f1b29, #070d14)",
              }}
              data-testid="hero-console-card"
            >
              <div className="flex items-center justify-between pb-4 border-b border-white/10 mb-4">
                <span className="text-[11px] font-mono-code text-[#E2C079] tracking-wider uppercase">{t.hero.console}</span>
                <span className="text-[10px] font-mono-code px-2 py-0.5 rounded bg-emerald-500/10 text-emerald-400 border border-emerald-500/20">{t.hero.live}</span>
              </div>
              <img
                src={DASHBOARD_IMG}
                alt={t.hero.console}
                className="w-full rounded border border-white/10 mb-4"
                loading="eager"
                data-testid="hero-dashboard-image"
              />
              <div className="pt-2 flex items-center justify-between text-[11px] text-white/60 font-mono-code">
                <span>{t.hero.foot1}</span>
                <span>{t.hero.foot2}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
